import React, { useEffect } from 'react';

import { ModalContext } from '@notino/react-styleguide-v20';

import { GeneralModalBody } from '@sharedComponents/GeneralModalBody';
import { ReactFCC } from '@types';
import { MODAL_SETTINGS_DEFAULT } from '@utils/constants';

import { useErrorContext } from '../../ErrorContext';

export const ErrorModalHandler: ReactFCC = ({ children }) => {
  const { toggleModal, hideModal } = ModalContext.useModalContext();
  const { errorState, clearErrorState } = useErrorContext();

  useEffect(() => {
    if (errorState) {
      const closeModal = () => {
        clearErrorState();
        hideModal();
      };

      toggleModal(
        <GeneralModalBody
          messagesText={errorState.messages}
          headerText={errorState.header}
          messagesBold={errorState.messageBold}
          buttonText={'Ok'}
          onButtonClick={closeModal}
          icon={errorState.icon}
        />,
        {
          ...MODAL_SETTINGS_DEFAULT,
          onClose: closeModal,
        },
      );
    }
  }, [errorState, toggleModal, clearErrorState, hideModal]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};
